import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
const faqs = [{
  q: "¿Necesito saber inglés para usar esto?",
  a: "No. Todo el sistema está diseñado para que la IA haga el trabajo pesado del idioma. Aprenderás a configurar las herramientas para que cada mensaje suene 100% nativo, aunque tu inglés no sea perfecto."
}, {
  q: "¿Es un curso de inglés?",
  a: "No. Es un sistema de ventas. No te enseñamos gramática, te damos el mapa exacto para prospectar, redactar propuestas y cerrar clientes en USA usando IA de próxima generación."
}, {
  q: "¿Cómo recibo el material?",
  a: "El acceso es 100% digital e inmediato. Apenas completes el pago, recibes por email el ebook y los 5 bonos para descargar al instante."
}, {
  q: "¿Por qué está tan barato?",
  a: "Porque queremos que pruebes nuestra metodología. Sabemos que cuando cierres tu primer contrato en dólares, volverás por nuestros productos de alto nivel. Es un trato justo."
}, {
  q: "¿Sirve para mi país?",
  a: "Sí. Funciona para freelancers, agencias y emprendedores de toda LATAM. Incluye una guía específica para cobrar en USD de forma legal y segura desde tu país."
}, {
  q: "¿Y si no me sirve?",
  a: "Tienes 7 días de garantía incondicional. Si no te convence, te devolvemos tu dinero completo y te quedas con el material."
}];
function Item({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="overflow-hidden rounded-xl border border-white/10 bg-white/[0.03]" data-id="element-86" data-mp="16pa2n0h7uf7m">
      <button onClick={() => setOpen(o => !o)} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left" aria-expanded={open} data-id="element-87" data-mp="s0maz5ahqpmy">
        <span className="font-semibold text-white" data-id="element-88" data-mp="izfqkl4q0uof">{q}</span>
        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-violet-400 transition-transform ${open ? "rotate-180" : ""}`} data-id="element-89" data-mp="mzyguaqytsoi" />
      </button>
      <AnimatePresence initial={false} data-id="element-90" data-mp="2po7w9dblcyts">
        {open && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: "auto",
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25
      }} data-id="element-91" data-mp="2kvewl3uzcgok">
            <p className="px-5 pb-4 text-sm leading-relaxed text-slate-300" data-id="element-92" data-mp="2az1zrx451mpl">{a}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  return <section className="w-full bg-[#0a0a1f] py-16" data-id="element-93" data-mp="33ng22p29f56y">
      <div className="mx-auto max-w-2xl px-4 sm:px-6" data-id="element-94" data-mp="33klcyk8aww77">
        <h2 className="text-center font-display text-2xl font-extrabold text-white sm:text-4xl" data-id="element-95" data-mp="2ym0din0vigjt">
          Preguntas frecuentes
        </h2>
        <div className="mt-8 space-y-3" data-id="element-96" data-mp="2uo2mdenjlkds">
          {faqs.map(f => <Item key={f.q} q={f.q} a={f.a} data-id="element-97" data-mp="1n9hhlgft6thd" />)}
        </div>
      </div>
    </section>;
}